if (document.querySelector('predictive-search')) {

    document.querySelectorAll('predictive-search').forEach(function(component) {
        var div = component.querySelector("form div");
        var temp_object = div?.querySelector("input");

        if (div && temp_object && !div.querySelector('.help-search-link')) {
            let new_link = document.createElement("a");
            new_link.href = "#";
            new_link.textContent = "¿No encuentras lo que buscabas?";
            new_link.className = "help-search-link";  
            new_link.rel = "nofollow";
            new_link.tabIndex = -1;
            div.insertBefore(new_link, temp_object);

            new_link.addEventListener("click", function(e) {
                e.preventDefault();
                askForHelp();
            });
        }
    });
}

  async function askForHelp() {
    var temp_data = (await getDatafromAPI()) || 'unknown';
    var userID = getClarityInfoCookie('_clck');
    var sessionID = getClarityInfoCookie('_clsk');
    var location = getCookie('localization');
    var savedUrl = getCookie('urlWithUTM') || 'Buscador';
    var page_location = window.location.href;

    sendReportToGoogleSheets({
      type: 'reporte',
      temp: temp_data,
      location: location,
      web_source: savedUrl,
      clarity_id: userID,
      clarity_session: sessionID,
      page_location: page_location,
    });
    return;
  }

  async function getDatafromAPI() {
    try {
      const response = await fetch('https://api.ipify.org/?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error obteniendo información:', error);
      return null;
    }
  }

  function getClarityInfoCookie(cookie_value) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === cookie_value) {
        // El Session ID es la primera parte antes del primer ^
        const decoded = decodeURIComponent(value);
        return decoded.split('^')[0];
      }
    }
    return 'Unknown';
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function sendReportToGoogleSheets(data) {
    fetch(
      'https://script.google.com/macros/s/AKfycbzKQHM4lP2v0gOT5fy7HO4uafrTp50sTCYrNjW2F15N5kdL1TzmlR3ElAw3THad6wFx/exec',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    );
  }